export default "__VITE_ASSET__92963613__"